import { isNativeTourModelEnabled } from '../../nativeTourModel';

export const PRICING_AND_INVENTORY_TAB_TYPE = 'pricing-and-inventory';

export const PRICING_AND_INVENTORY_TAB_TITLE = 'Pricing and inventory';

/**
 * The route itself is live everywhere, so the page can be reached by URL in
 * production. Only the nav tab is held back, keeping it out of the way of
 * production users who are not looking for it.
 */
export function isPricingAndInventoryTabVisible(): boolean {
  return isNativeTourModelEnabled();
}

/** Admin tour pages are keyed by legacy tour id, so a link to one is the only place it is read. */
export function pricingAndInventoryPath(legacyTourId: string): string {
  return `/tours/details/tour-${legacyTourId}/${PRICING_AND_INVENTORY_TAB_TYPE}`;
}
